// extracted by mini-css-extract-plugin
export default {"box__item":"style_box__item__jiC85"};